export const RatingStar = (floatNum) => {
  const integerPart = Math.floor(floatNum);
  const decimalPart = floatNum - integerPart;

  return decimalPart;
};
